/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import { Grid, GridCell, Icon, InlineFeature } from '../../components/core';
import type { IconName } from '../../components/core/Icon';
import MediaQueries from '../../constants/MediaQueries';
import Responsive from '../../constants/Responsive';

export type FeatureType = {
  icon?: IconName,
  title: string,
  description: string,
};

const DefaultFeatures: [FeatureType] = [
  {
    title: '30 minutes or 30 days',
    description:
      'Schedule your Lugg ahead of time up to 30 days in advance or request on-demand and we’ll arrive in as little as 30 minutes.',
    icon: 'pick-a-time',
  },
  {
    title: 'Pay, rate & tip',
    description:
      'When your Lugg is complete you’ll be asked to rate your Luggers with the option to tip them in the app for a job well done.',
    icon: 'rate-and-tip',
  },
  {
    title: 'Your stuff protected',
    description:
      'Each Lugg is backed by a multi-million dollar insurance policy from the moment your items are in our hands.',
    icon: 'shield',
  },
];

function ThreeFeaturesBlock({
  features = DefaultFeatures,
  theme = 'light',
}: {
  features: [FeatureType],
  theme?: 'light' | 'dark',
}) {
  return (
    <Grid equalHeight={true}>
      {features.map((feature, i, arr) => {
        let { title, description, icon } = feature;

        return (
          <GridCell size={Responsive('size12of12', 'size4of12')} key={i}>
            <InlineFeature
              theme={theme}
              className={names(
                Styles.InlineFeature,
                i === arr.length - 1 ? Styles.LastInlineFeature : null
              )}
              icon={icon && <Icon name={icon} />}
              title={title}
              description={description}
            />
          </GridCell>
        );
      })}
    </Grid>
  );
}

const Styles = {
  InlineFeature: css`
    margin-bottom: 56px;
    ${MediaQueries.Large} {
      margin-bottom: 0;
    }
  `,
  LastInlineFeature: css`
    margin-bottom: 0;
  `,
};

export default ThreeFeaturesBlock;



// WEBPACK FOOTER //
// ./src/ui/pages/components/ThreeFeaturesBlock.js